import Axios from 'axios'
import config from '@/config/config.js'
// import { MIME_TYPES_TO_FILE_EXTENSION } from '@/constant/constant'

const baseUrl = config.apiDomain.ALI + '/ext/pdf-service/pdf/'

Axios.defaults.headers.timeout = 8000

export default {

  dataMergeByExcel (excelDataDocumentId, wordTemplateDocumentId, fileName, cb) {
    let body = {
      excelDataDocumentId: excelDataDocumentId,
      wordTemplateDocumentId: wordTemplateDocumentId,
      fileName: fileName
    }
    Axios.post(baseUrl + 'dataMergeByExcel', body, { responseType: 'blob' }).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  checkSignatureFieldExists (documentId, signatureFieldName, cb) {
    Axios.get(baseUrl + 'checkSignatureFieldExists/' + documentId + '/' + signatureFieldName).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  }

}
